import React, { useEffect, useRef, useState } from 'react';
import agent from '../../../agent';
import {
  formatPrice,
  successAlert,
  warningAlert,
} from '../../../actions/actionCreators';
import i18n from '../../../i18nextInitiator';
import { connect } from 'react-redux';
import ButtonWithLoading from '../ButtonWithLoading';
import { useHistory } from 'react-router';
const t = i18n.getFixedT('fa', 'general');
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state.order });
/**
 * the component handles the payment functionality.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const Pay = (props) => {
  /**
   * the payable price for the order is calculated by decreasing the current user credit from the actual order price.
   * @type {number}
   */
  const payable = props.bill.price - props.bill.current_credit;

  //   const [urls, setUrls] = useState({ action: '', redirect: '' });
  const [handlingPayment, setHandlingPayment] = useState(false);
  const [showPayBtn, setShowPayBtn] = useState(false);
  const [btnText, setBtnText] = useState(
    `${t('invoice.pay')} ${formatPrice(payable)}`
  );

  const history = useHistory();

  /**
   * Ref of the hidden form to redirect to bank with post.
   * @type {React.MutableRefObject<undefined>}
   */
  const bankForm = useRef();

  /**
   * handle payment
   */
  const handlePayment = () => {
    console.log(props);
    let carIdName =
      props.order.car_id == 3
        ? 'بار سبک (وانت)'
        : props.order.car_id == 1
        ? 'بار سنگین (نیسان)'
        : 'اثاث کشی (کامیون)';
    setHandlingPayment(true);
    agent.Invoice.checkWallet({
      order_id: props.bill.id,
      by_credit: 1,
      type: 'webapp',
    }).then((res) => {
      if (res.status == '200') {
        if (res.data && res.data.is_enough) {
          successAlert(res.message);
        } else if (res.data && !res.data.is_enough) {
          agent.Invoice.pay({
            order_id: props.bill.id,
            amount: props.bill.price,
            type: 'webapp',
          }).then((res) => {
            if (res && res.status == '200' && res.data.token) {
              // history.push(
              //   `/payment/mid?url=${res.data.bank_url}&&redirectUrl=${res.data.redirect_url}&&token=${res.data.token}`
              // );
              window.gtag('event', 'checkout_progress', {
                items: [
                  {
                    id: props.order.car_id,
                    name: carIdName,
                    price: props.bill.price,
                  },
                ],
                coupon: '',
              });
              window.gtag('event', 'set_checkout_option', {
                checkout_step: 3,
                checkout_option: 'ثبت سفارش : پرداخت',
              });
              window.location.assign(
                `https://nobaar.com/orders/payment/mid?url=${res.data.bank_url}&&redirectUrl=${res.data.redirect_url}&&token=${res.data.token}&&billID=${props.bill.price}&&price=${props.bill.price}&&platform=${props.order.platform}&&cardID=${props.order.car_id}&&service=${carIdName}`
              );
            }
          });
        } else warningAlert(res.message);
      }
    });
  };

  useEffect(() => {
    if (payable <= 0) {
      setBtnText(
        `${formatPrice(props.bill.price)} ${t('invoice.increase-from-wallet')}`
      );
    }
  }, []);

  useEffect(() => {
    if (props.bill.status === 5) setShowPayBtn(true);
  }, [props.bill.status]);

  return (
    <>
      {/* <form
        ref={bankForm}
        style={{ display: 'none' }}
        action={urls.action}
        method="post"
      >
        <input name="RedirectURL" value={urls.redirect} />
        <input name="Token" value={urls.token} />
      </form> */}
      {showPayBtn && (
        <ButtonWithLoading
          disabled={payable <= 0}
          action={handlePayment}
          style={{ margin: '10px 0', fontSize: '1rem' }}
          loading={handlingPayment}
          text={btnText}
        />
      )}
    </>
  );
};
export default connect(mapStateToProps)(Pay);
